import React from "react";
import { IncomeStats } from "./IncomeStats";
import { ChannelsPie, PaymentMethodsPie, ProductsPie } from "./PieChart";
import { RevenueChart } from "./RevenueChart";

export const Analytics = () => {
    return (
        <div className="flex h-full w-full flex-col px-6 py-3">
            <div className="mb-6 w-full">
                <RevenueChart />
            </div>
            <div className="mb-10">
                <IncomeStats />
            </div>
            <div className="grid grid-cols-3">
                <PaymentMethodsPie />
                <ChannelsPie />
                <ProductsPie />
            </div>
        </div>
    );
};
